import { Controller } from "@hotwired/stimulus"
import { showToast } from "../kit_toast"

// Единая точка показа flash/ошибок — замена Toastr. Подключается к
// #flash-message/#error-messages (см. shared/_flash, shared/_errors),
// показывает тост и убирает себя из DOM.
export default class extends Controller {
  connect() {
    const type = this.element.dataset.toastType
    const message = this.element.dataset.toastMessage || this.element.innerHTML

    showToast(type, message)
    this.element.remove()
  }
}
